import axios from '@/axios';
import * as types from '../mutation-types'
import store from '../index';

export default {
	namespaced: true,

	state: {
		materialJournals: []
	},

	actions: {
		fetchAll({ state, commit }, { fromDate, toDate, isPosted, type, isUpdate } = {}) {
			if (!isUpdate && state.materialJournals.length) {
				/* eslint-disable-next-line */
				return Promise.resolve(state.materialJournals.filter(c => type ? c.type === type : true));
			}
			return axios.get('/materialJournal', {
				params: { fromDate, toDate, isPosted }
			}).then(data => {
				commit(types.STORE_MATERIAL_JOURNALS, data);
				return data.filter(c => type ? c.type === type : true);
			})
		},
		fetchById({ commit }, { id }) {	
			return axios.get(`/materialJournal/${id}`).then((data) => {
				return data;
			})
		},
		fetchEntires({ commit }, { journalId, fromDate, toDate, isPosted } = {}) {
			return axios.get(`/materialJournal/${journalId}/entries`).then(data => {
				return data.filter(c => !c.deletedAt);
			})
		},

		create({ commit }, { date, materialJournalType }) {
			return axios.post('/materialJournal', `${date}`, {
				params: { materialJournalType },
				headers: { 'Content-Type': 'application/json' }
			});
		},
		post({ commit }, { id }) {
			return axios.put(`/materialJournal/post/${id}`);
		},
		unpost({ commit }, { id }) {
			return axios.put(`/materialJournal/unpost/${id}`);
		},
		delete({ commit }, { id }) {
			return axios.delete(`/materialJournal/${id}`);
		},

		addEntry({ commit }, { journalId, inAmount, outAmount, accountId, ownerId, lot, itemId, date, notes }) {
			return axios.post('/itemTransaction', {
				materialsJournalId: journalId,
				in: inAmount,
				out: outAmount,
				accountId,
				ownerId,
				lot,
				itemId,
				date,
				warehouseId: store.state.warehouses.defaultWarhorseId,
				notes
			})
		},

		editEntry({ commit }, { id, journalId, inAmount, outAmount, accountId, ownerId, lot, itemId, date, notes }) {
			return axios.put(`/itemTransaction/${id}`, {
				materialsJournalId: journalId,
				in: inAmount,
				out: outAmount,
				accountId,
				ownerId,
				lot,
				itemId,
				date,
				warehouseId: store.state.warehouses.defaultWarhorseId,
				notes
			})
		},

		deleteEntry({ commit }, { id }) {
			return axios.delete(`/itemTransaction/${id}`)
		},

		reset({ commit }) {
			commit(types.RESET)
		}
	},

	mutations: {
		[types.STORE_MATERIAL_JOURNALS](state, journals) {
			state.materialJournals = journals;
		},
		
		[types.RESET](state) {
			state.materialJournals = [];
		}
	},

	getters: {
		getMaterialJournalById: state => id => state.materialJournals.find(c => c.id === id),
		getMaterialJournalByNo: state => no => state.materialJournals.find(c => c.journalNo === no),
	}
}